import React from 'react';
import { Script } from 'nordic/script';

const ImageLoader = () => <Script src="@frontend-performance/image-lazy-loading/src.js" on="now" inline />;

export default ImageLoader;
